module.exports = __webpack_public_path__ + "assets/e62fec4561309010d094dbbb2a0da1de.svg";